import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useLayoutEffect,
  useCallback,
} from "react";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputBase,
  Dialog,
  Tooltip,
  DialogTitle,
  DialogContent,
  DialogActions,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Autocomplete,
  LinearProgress,
  Divider,
  AlertTitle,
  Stack,
  CircularProgress,
} from "@mui/material";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Avatar from "@mui/material/Avatar";
import AddchartIcon from "@mui/icons-material/Addchart";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CategoryIcon from "@mui/icons-material/Category";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import axios from "axios";
import Alert from "@mui/material/Alert";
import Chip from "@mui/material/Chip";
import SaveIcon from "@mui/icons-material/Save";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FormGroup from "@mui/material/FormGroup";
import ScienceIcon from "@mui/icons-material/Science";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import LockIcon from "@mui/icons-material/Lock";
import Switch from "@mui/material/Switch";
// import ReactQuill from "react-quill";
// import CloseIcon from "@mui/icons-material/Close";
import ReactQuill, { Quill } from "react-quill-new";
import QuillTableBetter from "quill-table-better";
import "react-quill-new/dist/quill.snow.css";
import "quill-table-better/dist/quill-table-better.css";
import {
  BASE_URL,
  INITIAL_INVESTIGATION,
  MEDICAL_DEPTS,
  REPORT_TYPE,
  TARGET_TYPE,
} from "../../constants";
import "./TestHeaderForm.css";
import MethodRangeForm from "./MethodRangeForm";
import LabReport from "./LabReport";
import Radiology from "./Radiology";
import { formatDate } from "date-fns";
import ResultForm from "./ResultForm";
import Log from "../logDialog/Log";
import Widal from "./Widal";
import MicroBiology from "./MicroBiology";
import { toast } from "react-toastify";

const INITIAL_STATE = {
  testName: "",
  testDept: "",
  testCat: "",
  testPrice: "",
  reportType: "",
  interpretation: "",
  organizationId: "674fc5e059a81eeb7d4f94fb",
};
Quill.register({ "modules/table-better": QuillTableBetter }, true);
const TestHeaderForm = () => {
  const user = useRecoilValue(authState);
  const [formData, setFormData] = useState(INITIAL_STATE);
  const [investigations, setInvestigations] = useState(null);
  const [noOfInvestigations, setNoOfInvestigations] = useState(0);
  const [testList, setTestList] = useState([]);
  const [selectedTest, setSelectedTest] = useState(null);
  const [edit, setEdit] = useState(false);
  const [investigationIndex, setInvestigationIndex] = useState(0);
  const [subInvestigationIndex, setSubInvestigationIndex] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredTests, setFilteredTests] = useState(testList);
  const [open, setOpen] = useState(false);
  const [openResult, setOpenResult] = useState(false);
  const [openLabReport, setOpenLabReport] = useState(false);
  const [isSubInvestigation, setIsSubInvestigation] = useState(false);
  const [subInvestigationName, setSubInvestigationName] = useState(false);
  const [selectedRadiologyInvestigation, setSelectedRadiologyInvestigation] =
    useState(null);
  const [widalInvestigation, setWidalInvestigation] = useState([]);
  const [microBiologyInvestigation, setMicroBiologyInvestigation] = useState({
    organism: [""],
    compound: [""],
    text: "",
  });
  const quillRef = useRef(null);
  const quillRefEdit = useRef(null);
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: 1 }, { header: 2 }], // custom button values
          ["bold", "italic", "underline", "strike"], // toggled buttons
          ["table-better", "link", "image"], // Insert tools grouped together
          [{ list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ align: [] }],
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ size: ["small", false, "large", "huge"] }], // custom dropdown
          [{ font: [] }],
          [{ direction: "rtl" }], // text direction
        ],
      },
      table: false,
      "table-better": {
        language: "en_US",
        menus: [
          "column",
          "row",
          "merge",
          "table",
          "cell",
          "wrap",
          "copy",
          "delete",
        ],
        toolbarTable: true,
      },
      keyboard: {
        bindings: QuillTableBetter.keyboardBindings,
      },
    }),
    [],
  );
  const handleToggleEdit = (event) => {
    setEdit(event.target.checked);
  };
  const [loading, setLoading] = useState(false);
  const [testLoading, setTestLoading] = useState(false);

  const fetchTestList = async () => {
    setTestLoading(true);
    try {
      const response = await fetch(`${BASE_URL}api/user/common/test-header`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();

      if (result.success) {
        setTestList(result.data);
        setFilteredTests(result.data);
      } else {
        alert("Failed to fetch test list.");
      }
    } catch (error) {
      console.error("Error fetching test list:", error);
      alert("An error occurred while fetching the test list.");
    } finally {
      setTestLoading(false);
    }
  };
  useEffect(() => {
    fetchTestList();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //   const handleTestDetailChange = (e) => {
  //     const { name, value, type, checked } = e.target;
  //     setSelectedTestDetails((prevDetails) => ({
  //       ...prevDetails,
  //       [name]: type === "checkbox" ? checked : value,
  //     }));
  //   };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const {
      testName,
      testDept,
      testCat,
      testPrice,
      reportType,
      interpretation,
    } = formData;
    if (
      testName == "" ||
      testDept == "" ||
      testCat == "" ||
      testPrice == "" ||
      reportType == ""
    ) {
      alert("All fields are required");
      return;
    }
    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}api/user/common/test-header`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        alert(result.message);
        setFormData(INITIAL_STATE);
        window.location.reload();
        //setTestList((prevList) => [...prevList, result.data]);
        //fetchTestList();
      } else {
        alert(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error saving data:", error);
      alert("An error occurred while saving the test.");
    } finally {
      setLoading(false);
    }
  };
  console.log("selectedTest", selectedTest);
  const handleTestSelection = async (test) => {
    setLoading(true);
    setOpenModal(false);
    if (test.testCat === "pathology" && test.reportType === "Normal") {
      setSelectedTest(test);
      setEdit(false);
      try {
        const response = await axios.get(
          `${BASE_URL}api/user/pathology/get-pathology-investigation?testId=${test._id}`,
          {
            headers: {},
          },
        );
        const data = response.data;
        if (data.onOfInvestigations === 0) {
          setInvestigations([
            {
              name: "",
              // methods: null,
              methods: [],
              subInvestigations: [],
            },
          ]);
          setNoOfInvestigations(0);
        } else {
          setInvestigations(data.investigations[0].investigations);
          setNoOfInvestigations(data.onOfInvestigations);
        }
      } catch (err) {
        alert("Somethig went wrong");
      } finally {
        setLoading(false);
      }
    } else if (test.testCat === "radiology") {
      setSelectedTest(test);
      setEdit(false);
      setSelectedRadiologyInvestigation(null);
      try {
        const response = await axios.get(
          `${BASE_URL}api/user/radiology/get-radiology-investigation?testId=${test._id}`,
          {
            headers: {},
          },
        );
        const data = response.data;
        console.log("RRRRR", data);
        if (data.noOfInvestigations === 0) {
          setSelectedRadiologyInvestigation([
            {
              formatName: "",
              testContent: "",
            },
          ]);
          setNoOfInvestigations(0);
        } else {
          setSelectedRadiologyInvestigation(data.investigation.investigations);
          setNoOfInvestigations(data.noOfInvestigations);
        }
      } catch (err) {
        setSelectedRadiologyInvestigation(null);
        alert("Something went wrong");
      } finally {
        setLoading(false);
      }
    } else if (test.testCat === "pathology" && test.reportType === "Widal") {
      setSelectedTest(test);
      setEdit(false);
      try {
        const response = await axios.get(
          `${BASE_URL}api/user/pathology/get-pathology-investigation?testId=${test._id}`,
          {
            headers: {},
          },
        );
        const data = response.data;
        if (data?.investigations[0]?.widalInvestigations.length > 0) {
          setWidalInvestigation(data.investigations[0].widalInvestigations);
        } else {
          setWidalInvestigation([]);
        }
      } catch (err) {
        alert("Somethig went wrong");
      } finally {
        setLoading(false);
      }
    } else if (test.testCat === "microbiology") {
      setSelectedTest(test);
      setEdit(false);
      try {
        const response = await axios.get(
          `${BASE_URL}api/user/microbiology/get-microbiology-investigation/${test._id}`,
          {
            headers: {},
          },
        );
        const data = response.data;
        console.log("MMM", data);
        if (
          data?.investigations?.compound.length > 0 ||
          data?.investigations?.organism.length > 0 ||
          data?.investigations?.text.length > 0
        ) {
          setMicroBiologyInvestigation({
            organism: data?.investigations?.organism,
            compound: data?.investigations?.compound,
            text: data?.investigations?.text,
          });
        } else {
          setMicroBiologyInvestigation({
            organism: [],
            compound: [],
            text: "",
          });
        }
      } catch (err) {
        console.log(err);
        if (err.response.status === 404) {
          setMicroBiologyInvestigation({
            organism: [],
            compound: [],
            text: "",
          });
        }
      } finally {
        setLoading(false);
      }
    }
  };
  const handleInputChange = (index, e, field) => {
    const { name, value } = e.target;

    setInvestigations((prevInvestigations) => {
      const updatedInvestigations = [...prevInvestigations];

      if (field === "subInvestigations") {
        const [subIndex, subField] = name.split("-");
        updatedInvestigations[index].subInvestigations[subIndex] = {
          ...updatedInvestigations[index].subInvestigations[subIndex],
          [subField]: value,
        };
      } else {
        updatedInvestigations[index] = {
          ...updatedInvestigations[index],
          [name]: value,
        };
      }

      return updatedInvestigations;
    });
  };

  const handleAddInvestigation = () => {
    setInvestigations((prevInvestigations) => [
      ...prevInvestigations,
      {
        name: "",
        method: null,
        subInvestigations: [],
      },
    ]);
  };
  const handleRemoveInvestigation = (index) => {
    setInvestigations((prevInvestigations) =>
      prevInvestigations.filter((_, i) => i !== index),
    );
  };

  const handleAddSubInvestigation = (investigationIndex) => {
    setInvestigations((prevInvestigations) => {
      const updatedInvestigations = [...prevInvestigations];
      updatedInvestigations[investigationIndex].subInvestigations.push({
        subInvestigationName: "",
      });
      return updatedInvestigations;
    });
  };

  const handleRemoveSubInvestigation = (investigationIndex, subIndex) => {
    setInvestigations((prevInvestigations) => {
      const updatedInvestigations = [...prevInvestigations];
      updatedInvestigations[investigationIndex].subInvestigations =
        updatedInvestigations[investigationIndex].subInvestigations.filter(
          (_, i) => i !== subIndex,
        );
      return updatedInvestigations;
    });
  };

  const handleInvestigationChange = (index, e) => {
    handleInputChange(index, e, "investigation");
  };

  const handleSubInvestigationChange = (investigationIndex, subIndex, e) => {
    const modifiedEvent = {
      target: {
        ...e.target,
        name: `${subIndex}-${e.target.name}`,
      },
    };
    setSubInvestigationName(modifiedEvent.target.value);
    handleInputChange(investigationIndex, modifiedEvent, "subInvestigations");
  };

  // function clearResultsIfMinMaxExist(investigations) {
  //   return investigations.map((investigation) => {
  //     const hasMinMax = investigation.methods.some((method) =>
  //       method.ranges.some((range) => range.min !== null && range.max !== null)
  //     );

  //     return hasMinMax ? { ...investigation, results: [] } : investigation;
  //   });
  // }

  // function clearResultsIfMinMaxExist(investigations) {
  //   return investigations.map((investigation) => {
  //     const hasMinMax = investigation.methods.some((method) =>
  //       method.ranges.some((range) => range.min !== null && range.max !== null)
  //     );

  //     return {
  //       ...investigation,
  //       results: hasMinMax ? [] : investigation.results,
  //       subInvestigations: investigation.subInvestigations.map(
  //         (subInvestigation) => ({
  //           ...subInvestigation,
  //           results: hasMinMax ? [] : subInvestigation.results,
  //         })
  //       ),
  //     };
  //   });
  // }
  function clearResultsIfMinMaxExist(investigations) {
    return investigations.map((investigation) => {
      const hasValidRange = investigation?.methods?.some((method) =>
        method?.ranges?.some(
          (range) =>
            range.min !== null &&
            range.min !== "" &&
            range.max !== null &&
            range.max !== "",
        ),
      );

      return {
        ...investigation,
        results: hasValidRange ? [] : investigation.results,
      };
    });
  }

  const saveInvestigation = async () => {
    const invData = clearResultsIfMinMaxExist(investigations);
    const data = {
      testId: selectedTest._id,
      investigations: invData,
    };
    console.log("66666", investigations, invData);
    try {
      setLoading(true);
      const response = await fetch(
        `${BASE_URL}api/user/pathology/create-pathology-investigation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );
      const resp = await response.json();
      if (resp.success) {
        alert(resp.message);
        setInvestigations(null);
        setSelectedTest(null);
      } else {
        alert(resp.message);
      }
    } catch (err) {
      alert(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const updateInvestigation = async () => {
    try {
      setLoading(true);
      console.log("UUPP11111", investigations);
      const data = clearResultsIfMinMaxExist(investigations);
      console.log("UUPPP2222", data);
      const response = await axios.put(
        `${BASE_URL}api/user/pathology/update-pathology-investigation`,
        {
          data: { testId: selectedTest._id, investigations: data },
        },
        {
          headers: {},
        },
      );

      if (response.data.success) {
        alert(response.data.message);
      } else {
        alert(response.data.message);
      }
    } catch (err) {
      alert("Server error");
    } finally {
      setEdit(false);
      setLoading(false);
    }
  };

  const handleSearchChange = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);

    // Filter across multiple fields
    const filtered = testList.filter((test) => {
      return (
        test.testName.toLowerCase().includes(query) || // Match testName
        test.testDept.toLowerCase().includes(query) || // Match testDept
        test.testCat.toLowerCase().includes(query) || // Match testCat
        test.testPrice.toString().includes(query) // Match testPrice
      );
    });

    setFilteredTests(filtered); // Update filtered list
  };

  const handleClickOpen = (index, subIndex = -1, sub = false) => {
    setOpen(true);
    setIsSubInvestigation(sub);
    setInvestigationIndex(index);
    setSubInvestigationIndex(subIndex);
  };

  const handleClickOpenResult = (index, subIndex = -1, sub = false) => {
    setOpenResult(true);
    setIsSubInvestigation(sub);
    setInvestigationIndex(index);
    setSubInvestigationIndex(subIndex);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseResult = () => {
    setOpenResult(false);
  };

  const handleLabReport = () => {
    setOpenLabReport(!openLabReport);
  };

  const [draggedIndex, setDraggedIndex] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (event, index) => {
    // Prevent default to allow drop
    event.preventDefault();

    // If the dragged item is dragged over a different index
    if (draggedIndex !== index) {
      setHoverIndex(index);
      const updatedItems = [...investigations];
      const [draggedItem] = updatedItems.splice(draggedIndex, 1);
      updatedItems.splice(index, 0, draggedItem);

      setDraggedIndex(index);
      setInvestigations(updatedItems);
    }
  };

  const handleDrop = () => {
    setDraggedIndex(null); // Reset dragged index
    setHoverIndex(null);
  };

  const toolbarOptions = [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline", "strike"],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["blockquote"],
    [{ script: "sub" }, { script: "super" }],
    [{ size: ["small", "medium", "large", "huge"] }],
  ];

  const [openModal, setOpenModal] = useState(false);

  const handleUpdateHeader = async (e) => {
    e.preventDefault();
    const { testName, testDept, testPrice, reportType, interpretation } =
      selectedTest;
    if (
      testName == "" ||
      testDept == "" ||
      testPrice == "" ||
      reportType == ""
    ) {
      alert("All fields are required");
      return;
    }
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/test-header/${selectedTest._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(selectedTest),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert(result.message);
        setOpenModal(false);
        fetchTestList();
      } else {
        alert(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error saving data:", error);
      alert("An error occurred while saving the test.");
    }
  };

  const [openLogDialog, setOpenLogDialog] = useState(false);
  const [headerLogs, setHeaderLogs] = useState(null);
  const handleViewLog = async (testId, type) => {
    setOpenLogDialog(true);
    let targetType;
    if (type === "header") targetType = TARGET_TYPE.testHeader;
    else if (type === "pathologyInvestigation")
      targetType = TARGET_TYPE.pathologyInvestigation;
    else if (type === "radiologyInvestigation")
      targetType = TARGET_TYPE.radiologyInvestigation;

    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-logs?id=${testId}&targetType=${targetType}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const headers = await response.json();
      setHeaderLogs(headers.logs);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      // setLoading(false);
    }
  };
  const handleCloseLog = () => {
    setOpenLogDialog(false);
  };

  const [displayTestDeleteConfirm, setDisplayTestDeleteConfirm] =
    useState(false);
  const [testForDelete, setTestForDelete] = useState(null);

  const handleTestDelete = (test) => {
    setTestForDelete(test);
    setDisplayTestDeleteConfirm(true);
  };

  const handleConfirmTestDelete = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/test-header-delete?id=${testForDelete._id}&testCat=${testForDelete._testCat}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const resp = await response.json();

      if (response.ok) {
        toast.success(resp.message || "Test deleted successfully");
        // Optionally refresh the list or close modal
        fetchTestList();
      } else {
        toast.error(resp.message || "Failed to delete test");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
      console.error(err);
    } finally {
      setDisplayTestDeleteConfirm(false);
    }
  };

  const [disableLoading, setDisableLoading] = useState(false);
  const handleDisableTest = async () => {
    setDisableLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/test-disable?id=${selectedTest._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const resp = await response.json();

      if (response.ok) {
        toast.success(resp.message || "Test disabled successfully");
        console.log(selectedTest);
        setSelectedTest((prev) => ({
          ...prev,
          isEnabled: !prev.isEnabled,
        }));
      } else {
        toast.error(resp.message || "Failed to disable test");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setDisableLoading(false);
    }
  };

  const loadInterpretationIntoQuill = useCallback(
    (content) => {
      if (!quillRefEdit.current) {
        setTimeout(() => {
          if (quillRefEdit.current) {
            loadInterpretationIntoQuill(content);
          }
        }, 60);
        return;
      }

      const editor = quillRefEdit.current.getEditor?.() || quillRefEdit.current;
      if (!editor || !editor.clipboard) return;

      const html = (
        content !== undefined ? content : selectedTest?.interpretation || ""
      ).trim();
      const currentHTML = editor.root?.innerHTML?.trim() || "";

      if (currentHTML === html) return;

      if (!html || html === "<p><br></p>") {
        editor.setContents([], Quill.sources.SILENT);
        return;
      }

      try {
        const delta = editor.clipboard.convert({ html });
        editor.setContents([], Quill.sources.SILENT);
        editor.updateContents(delta, Quill.sources.USER);

        const [range] = editor.selection ? editor.selection.getRange() : [null];
        if (range) {
          editor.setSelection(
            Math.max(0, delta.length() - (range?.length || 0)),
            Quill.sources.SILENT,
          );
          editor.scrollSelectionIntoView();
        }
      } catch (err) {
        console.error("Error setting quill interpretation:", err);
      }
    },
    [selectedTest?.interpretation],
  );

  useLayoutEffect(() => {
    if (openModal) {
      loadInterpretationIntoQuill(selectedTest?.interpretation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal, selectedTest?._id]);

  return (
    <>
      <Dialog open={openLabReport} onClose={handleLabReport}>
        <LabReport investigations={investigations} />
      </Dialog>
      {/* <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="lg"
        fullWidth
        TransitionProps={{
          onEntered: () => {
            loadInterpretationIntoQuill();
          },
        }}
      >
        <DialogContent
          sx={{
            paddingTop: "25px !important",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Test Name"
                  name="testName"
                  value={selectedTest?.testName}
                  onChange={(e) =>
                    setSelectedTest({
                      ...selectedTest,
                      testName: e.target.value,
                    })
                  }
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={MEDICAL_DEPTS}
                  getOptionLabel={(option) => `${option}`}
                  value={selectedTest?.testDept}
                  required
                  onChange={(event, newValue) => {
                    setSelectedTest({ ...selectedTest, testDept: newValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Department"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={selectedTest?.testDept}
                      required
                      sx={{ backgroundColor: "white" }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  disableClearable
                  noOptionsText={`No Department found`}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth required variant="outlined" size="small">
                  <InputLabel>Test Category</InputLabel>
                  <Select
                    label="Test Category"
                    name="testCat"
                    value={selectedTest?.testCat}
                    onChange={(e) =>
                      setSelectedTest({
                        ...selectedTest,
                        testPrice: e.target.value,
                      })
                    }
                    disabled={true}
                  >
                    <MenuItem value="pathology">Pathology</MenuItem>
                    <MenuItem value="microbiology">Microbiology</MenuItem>
                    <MenuItem value="radiology">Radiology</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  label="Test Price"
                  name="testPrice"
                  type="number"
                  value={selectedTest?.testPrice}
                  onChange={(e) =>
                    setSelectedTest({
                      ...selectedTest,
                      testPrice: e.target.value,
                    })
                  }
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  inputProps={{ min: 0 }}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  select
                  label="Select Report Type"
                  value={selectedTest?.reportType}
                  fullWidth
                  size="small"
                  required
                  onChange={(event, newValue) => {
                    setSelectedTest({
                      ...selectedTest,
                      reportType: newValue.props.value,
                    });
                  }}
                >
                  {REPORT_TYPE.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sx={12} sm={12}>
                <ReactQuill
                  ref={quillRefEdit}
                  theme="snow"
                  modules={modules}
                  onChange={(value) =>
                    setSelectedTest({
                      ...selectedTest,
                      interpretation: value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleUpdateHeader}
                >
                  Update Test Header
                </Button>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog> */}
      <Dialog
        open={displayTestDeleteConfirm}
        onClose={() => setDisplayTestDeleteConfirm(false)}
        fullWidth
      >
        <DialogContent>
          <Alert
            severity="warning"
            sx={{ mb: 3, borderRadius: 2, width: "100%" }}
          >
            <AlertTitle>Delete Confirm</AlertTitle>
            Are you sure you want to delete{" "}
            <strong>{testForDelete?.testName}</strong>?
          </Alert>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="text"
              color="primary"
              onClick={() => setDisplayTestDeleteConfirm(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleConfirmTestDelete}
            >
              Confirm
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Grid container spacing={2}>
        {/* Popup Dialog */}
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle sx={{ paddingBottom: 0 }}>
            Create Method and it's Ranges
          </DialogTitle>
          <MethodRangeForm
            investigations={investigations}
            investigationIndex={investigationIndex}
            setInvestigations={setInvestigations}
            isSubInvestigation={isSubInvestigation}
            subInvestigationIndex={subInvestigationIndex}
            subInvestigationName={subInvestigationName}
            handleClose={handleClose}
          />
        </Dialog>
        <Dialog open={openResult} onClose={handleCloseResult}>
          <DialogTitle sx={{ paddingBottom: 0 }}>Results</DialogTitle>
          <ResultForm
            investigations={investigations}
            investigationIndex={investigationIndex}
            setInvestigations={setInvestigations}
            isSubInvestigation={isSubInvestigation}
            subInvestigationIndex={subInvestigationIndex}
            subInvestigationName={subInvestigationName}
            handleClose={handleClose}
          />
        </Dialog>
        {/* Form Section */}
        <Grid item xs={12} md={9}>
          {user?._doc?.permissions?.testHeaderManagement?.create &&
            !openModal && (
              <Accordion
                sx={{
                  borderRadius: "14px !important",
                  background: "#ffffff",
                  border: "1px solid #e5e9ef",
                  boxShadow: "0 2px 12px rgba(10,31,68,0.06)",
                  "&:before": { display: "none" },
                  "&.Mui-expanded": {
                    margin: 0,
                    boxShadow: "0 8px 28px rgba(10,31,68,0.1)",
                  },
                  overflow: "hidden",
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: "8px",
                        background: "linear-gradient(135deg,#0f6e56,#1d9e75)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <ExpandMoreIcon sx={{ color: "#fff" }} />
                    </Box>
                  }
                  sx={{
                    background: "#ffffff",
                    borderBottom: "1px solid #e5e9ef",
                    px: 2,
                    minHeight: "56px !important",
                    "&.Mui-expanded": {
                      minHeight: "56px !important",
                    },
                    "& .MuiAccordionSummary-content": {
                      margin: "12px 0 !important",
                    },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: "9px",
                        background: "linear-gradient(135deg,#0f6e56,#1d9e75)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 12px rgba(16,185,129,.3)",
                      }}
                    >
                      <ScienceIcon sx={{ color: "#fff", fontSize: "1rem" }} />
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontSize: ".95rem",
                          fontWeight: 700,
                          color: "#064e3b",
                        }}
                      >
                        Create Test Header
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: ".68rem",
                          color: "#94a3b8",
                          mt: "1px",
                        }}
                      >
                        Configure laboratory test details
                      </Typography>
                    </Box>
                  </Box>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    background: "#f8fafc",
                    p: 2.5,
                  }}
                >
                  <Box>
                    <Grid container spacing={2}>
                      {/* Test Name, Department (Dropdown), Cat, Price, ReportType, Interpretation (Rich Text Quill)*/}
                      <Grid item xs={12} sm={6}>
                        <>
                          <Typography sx={labelStyle}>Test Name</Typography>
                          <TextField
                            sx={fieldStyle}
                            name="testName"
                            value={formData?.testName}
                            onChange={handleChange}
                            fullWidth
                            required
                            variant="outlined"
                            size="small"
                          />
                        </>
                      </Grid>

                      {/* Test Department */}
                      <Grid item xs={12} sm={6}>
                        <>
                          <Typography sx={labelStyle}>
                            Select Department
                          </Typography>
                          <Autocomplete
                            options={MEDICAL_DEPTS}
                            getOptionLabel={(option) => `${option}`}
                            value={formData?.testDept}
                            required
                            sx={fieldStyle}
                            onChange={(event, newValue) => {
                              setFormData({ ...formData, testDept: newValue });
                            }}
                            // onInputChange={(event, newInputValue) => {
                            //   setPatientSearchInput(newInputValue);
                            // }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={formData?.testDept}
                                required
                                sx={{ backgroundColor: "white" }}
                              />
                            )}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            disableClearable
                            noOptionsText={`No Department found`}
                          />
                        </>
                      </Grid>

                      {/* Test Category */}
                      <Grid item xs={12} sm={4}>
                        <>
                          <Typography sx={labelStyle}>Test Category</Typography>
                          <FormControl
                            fullWidth
                            required
                            variant="outlined"
                            size="small"
                            sx={fieldStyle}
                          >
                            <Select
                              name="testCat"
                              value={formData?.testCat}
                              onChange={handleChange}
                            >
                              <MenuItem value="pathology">Pathology</MenuItem>
                              <MenuItem value="microbiology">
                                Microbiology
                              </MenuItem>
                              <MenuItem value="radiology">Radiology</MenuItem>
                            </Select>
                          </FormControl>
                        </>
                      </Grid>

                      {/* Test Price */}
                      <Grid item xs={12} sm={4}>
                        <>
                          <Typography sx={labelStyle}>Test Price</Typography>
                          <TextField
                            name="testPrice"
                            type="number"
                            sx={fieldStyle}
                            value={formData?.testPrice}
                            onChange={handleChange}
                            fullWidth
                            required
                            variant="outlined"
                            size="small"
                            inputProps={{ min: 0 }}
                          />
                        </>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <>
                          <Typography sx={labelStyle}>
                            Select Report Type
                          </Typography>
                          <TextField
                            select
                            sx={fieldStyle}
                            value={formData?.reportType}
                            fullWidth
                            size="small"
                            required
                            // onChange={handleChange}
                            onChange={(event, newValue) => {
                              setFormData({
                                ...formData,
                                reportType: newValue.props.value,
                              });
                            }}
                          >
                            {REPORT_TYPE.map((type) => (
                              <MenuItem key={type} value={type}>
                                {type}
                              </MenuItem>
                            ))}
                          </TextField>
                        </>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <Box
                          sx={{
                            background: "#fff",
                            borderRadius: "10px",
                            border: "1px solid #e2e8f0",
                            overflow: "visible",
                            position: "relative",

                            "& .ql-toolbar": {
                              background: "#f8fafc",
                              borderColor: "#e2e8f0",
                              borderTopLeftRadius: "9px",
                              borderTopRightRadius: "9px",
                              position: "relative",
                              zIndex: 10,
                            },
                            "& .ql-container": {
                              borderColor: "#e2e8f0",
                              borderBottomLeftRadius: "9px",
                              borderBottomRightRadius: "9px",
                              fontFamily: "inherit",
                            },
                            "& .ql-editor": {
                              minHeight: "180px",
                              maxHeight: "380px",
                              overflowY: "auto",
                              fontSize: "0.88rem",
                              lineHeight: 1.6,
                              color: "#1e293b",
                              "& table": {
                                borderCollapse: "collapse",
                                width: "100%",
                                my: 1,
                              },
                              "& th, & td": {
                                border: "1px solid #cbd5e1",
                                padding: "6px 10px",
                                minWidth: "40px",
                              },
                              "& th": {
                                background: "#f1f5f9",
                                fontWeight: 600,
                              },
                            },
                          }}
                        >
                          <ReactQuill
                            ref={quillRef}
                            theme="snow"
                            modules={modules}
                            placeholder="Test Interpretation..."
                            onChange={(content) =>
                              setFormData((prev) => ({
                                ...prev,
                                interpretation: content,
                              }))
                            }
                          />
                        </Box>
                      </Grid>

                      {/* Submit Button */}
                      <Grid item xs={12} sm={12} sx={{ display: "flex" }}>
                        <Button
                          variant="contained"
                          // fullWidth
                          onClick={handleSubmit}
                          disabled={loading}
                          sx={{
                            background: loading
                              ? "#e5e9ef"
                              : "linear-gradient(135deg,#0f6e56,#1d9e75)",
                            marginLeft: "auto",
                            color: "#fff",

                            fontWeight: 700,
                            fontSize: ".84rem",
                            textTransform: "none",

                            borderRadius: "10px",

                            py: 1.2,

                            boxShadow: "0 4px 14px rgba(16,185,129,.3)",

                            "&:hover": {
                              background:
                                "linear-gradient(135deg,#064e3b,#0f6e56)",
                            },
                          }}
                        >
                          {loading ? "Saving Test..." : "Save Test"}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </AccordionDetails>
              </Accordion>
            )}

          {loading && (
            <LinearProgress
              color="success"
              sx={{ height: 2, mt: 1, width: "100%" }}
            />
          )}
          {openModal && (
            <Box
              sx={{
                p: 2.5,
                borderRadius: "16px",
                background:
                  "linear-gradient(135deg, rgba(34,197,94,0.08), rgba(16,185,129,0.05))",
                border: "1px solid #d1fae5",
                boxShadow: "0 8px 24px rgba(16,185,129,0.08)",
              }}
            >
              {/* 🔥 HEADER */}
              <Box sx={{ mb: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        fontWeight: 700,
                        color: "#065f46",
                      }}
                    >
                      Test Header
                    </Typography>
                    <Typography sx={{ fontSize: "0.72rem", color: "#6b7280" }}>
                      Configure test details and report structure
                    </Typography>
                  </Box>
                  <Button
                    onClick={() => setOpenModal(false)}
                    sx={{
                      height: 36,
                      borderRadius: "8px",
                      px: 2,
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      textTransform: "none",

                      background: "#fee2e2",
                      color: "#dc2626",

                      "&:hover": {
                        background: "#fecaca",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>

              <Grid container spacing={2}>
                {/* TEST NAME */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Test Name"
                    name="testName"
                    value={selectedTest?.testName}
                    onChange={(e) =>
                      setSelectedTest({
                        ...selectedTest,
                        testName: e.target.value,
                      })
                    }
                    fullWidth
                    required
                    size="small"
                    sx={inputStyle}
                  />
                </Grid>

                {/* TEST DEPARTMENT */}
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    options={MEDICAL_DEPTS}
                    getOptionLabel={(option) => `${option}`}
                    value={selectedTest?.testDept}
                    onChange={(event, newValue) => {
                      setSelectedTest({
                        ...selectedTest,
                        testDept: newValue,
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Department"
                        size="small"
                        fullWidth
                        required
                        sx={inputStyle}
                      />
                    )}
                    disableClearable
                  />
                </Grid>

                {/* CATEGORY */}
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth size="small" required>
                    <InputLabel>Test Category</InputLabel>
                    <Select
                      label="Test Category"
                      value={selectedTest?.testCat}
                      disabled
                      sx={inputStyle}
                    >
                      <MenuItem value="pathology">Pathology</MenuItem>
                      <MenuItem value="microbiology">Microbiology</MenuItem>
                      <MenuItem value="radiology">Radiology</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* PRICE */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Test Price"
                    type="number"
                    value={selectedTest?.testPrice}
                    onChange={(e) =>
                      setSelectedTest({
                        ...selectedTest,
                        testPrice: e.target.value,
                      })
                    }
                    fullWidth
                    required
                    size="small"
                    sx={inputStyle}
                    inputProps={{ min: 0 }}
                  />
                </Grid>

                {/* REPORT TYPE */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    select
                    label="Select Report Type"
                    value={selectedTest?.reportType}
                    fullWidth
                    size="small"
                    required
                    sx={inputStyle}
                    onChange={(event) => {
                      setSelectedTest({
                        ...selectedTest,
                        reportType: event.target.value,
                      });
                    }}
                  >
                    {REPORT_TYPE.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* QUILL EDITOR */}
                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#fff",
                      borderRadius: "10px",
                      border: "1px solid #d1fae5",
                      overflow: "visible",
                      position: "relative",
                      "& .ql-toolbar": {
                        background: "#f8fafc",
                        borderColor: "#d1fae5",
                        borderTopLeftRadius: "9px",
                        borderTopRightRadius: "9px",
                        position: "relative",
                        zIndex: 10,
                      },
                      "& .ql-container": {
                        borderColor: "#d1fae5",
                        borderBottomLeftRadius: "9px",
                        borderBottomRightRadius: "9px",
                        fontFamily: "inherit",
                      },
                      "& .ql-editor": {
                        minHeight: "180px",
                        maxHeight: "380px",
                        overflowY: "auto",
                        fontSize: "0.88rem",
                        lineHeight: 1.6,
                        color: "#1e293b",
                        "& table": {
                          borderCollapse: "collapse",
                          width: "100%",
                          my: 1,
                        },
                        "& th, & td": {
                          border: "1px solid #cbd5e1",
                          padding: "6px 10px",
                          minWidth: "40px",
                        },
                        "& th": {
                          background: "#f1f5f9",
                          fontWeight: 600,
                        },
                      },
                    }}
                  >
                    <ReactQuill
                      ref={quillRefEdit}
                      theme="snow"
                      modules={modules}
                      placeholder="Test Interpretation..."
                      onChange={(value) =>
                        setSelectedTest((prev) => ({
                          ...prev,
                          interpretation: value,
                        }))
                      }
                    />
                  </Box>
                </Grid>

                {/* SUBMIT BUTTON */}
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    onClick={handleUpdateHeader}
                    sx={{
                      mt: 1,
                      height: 42,
                      borderRadius: "10px",
                      fontWeight: 700,
                      fontSize: "0.85rem",
                      textTransform: "none",

                      background: "linear-gradient(135deg,#16a34a,#22c55e)",
                      color: "#fff",

                      boxShadow: "0 6px 18px rgba(34,197,94,0.35)",

                      "&:hover": {
                        background: "linear-gradient(135deg,#15803d,#16a34a)",
                      },
                    }}
                  >
                    Update Test Header
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}
          {investigations &&
            selectedTest?.testCat === "pathology" &&
            selectedTest?.reportType === "Normal" && (
              <Box
                sx={{
                  mt: 3,
                  p: 3,
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                  backgroundColor: "#fff",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 1.5,
                    mb: 2,
                  }}
                >
                  {/* ── Left: test info + actions ── */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    {/* Test name chip */}
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.75,
                        background:
                          "linear-gradient(135deg, rgba(42,84,166,0.1), rgba(185,58,207,0.08))",
                        border: "1px solid rgba(185,58,207,0.2)",
                        borderRadius: "100px",
                        px: 1.25,
                        py: 0.5,
                      }}
                    >
                      <AddchartIcon
                        sx={{ fontSize: "0.85rem", color: "#2a54a6" }}
                      />
                      <Typography
                        sx={{
                          fontSize: "0.78rem",
                          fontWeight: 700,
                          background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          backgroundClip: "text",
                        }}
                      >
                        {selectedTest?.testName}
                      </Typography>
                    </Box>

                    {/* Category chip */}
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.75,
                        background: "rgba(42,84,166,0.06)",
                        border: "1px solid rgba(42,84,166,0.15)",
                        borderRadius: "100px",
                        px: 1.25,
                        py: 0.5,
                      }}
                    >
                      <CategoryIcon
                        sx={{ fontSize: "0.82rem", color: "#2a54a6" }}
                      />
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          color: "#2a54a6",
                        }}
                      >
                        {selectedTest?.testCat}
                      </Typography>
                    </Box>

                    {/* Price chip */}
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.5,
                        background: "rgba(16,185,129,0.08)",
                        border: "1px solid rgba(16,185,129,0.2)",
                        borderRadius: "100px",
                        px: 1.25,
                        py: 0.5,
                      }}
                    >
                      <CurrencyRupeeIcon
                        sx={{ fontSize: "0.82rem", color: "#059669" }}
                      />
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          fontWeight: 700,
                          color: "#059669",
                          fontFamily: "monospace",
                        }}
                      >
                        {selectedTest?.testPrice}
                      </Typography>
                    </Box>

                    {/* Edit header + disable/enable */}
                    {user?._doc?.permissions?.testHeaderManagement?.edit && (
                      <>
                        <Button
                          size="small"
                          onClick={() => setOpenModal(true)}
                          startIcon={
                            <EditIcon sx={{ fontSize: "0.78rem !important" }} />
                          }
                          sx={{
                            textTransform: "none",
                            fontSize: "0.72rem",
                            fontWeight: 700,
                            borderRadius: "8px",
                            px: 1.25,
                            py: 0.5,
                            background:
                              "linear-gradient(135deg,#2a54a6,#b93acf)",
                            color: "#fff",
                            boxShadow: "0 3px 8px rgba(185,58,207,0.25)",
                            "&:hover": {
                              background:
                                "linear-gradient(135deg,#1e3d8a,#a02db8)",
                              boxShadow: "0 4px 12px rgba(185,58,207,0.35)",
                            },
                          }}
                        >
                          Edit Header
                        </Button>

                        <Button
                          size="small"
                          onClick={handleDisableTest}
                          disabled={disableLoading}
                          startIcon={
                            selectedTest?.isEnabled ? (
                              <BlockIcon
                                sx={{ fontSize: "0.78rem !important" }}
                              />
                            ) : (
                              <CheckCircleIcon
                                sx={{ fontSize: "0.78rem !important" }}
                              />
                            )
                          }
                          sx={{
                            textTransform: "none",
                            fontSize: "0.72rem",
                            fontWeight: 700,
                            borderRadius: "8px",
                            px: 1.25,
                            py: 0.5,
                            border: "1.5px solid",
                            borderColor: selectedTest?.isEnabled
                              ? "rgba(239,68,68,0.3)"
                              : "rgba(16,185,129,0.3)",
                            color: selectedTest?.isEnabled
                              ? "#dc2626"
                              : "#059669",
                            background: selectedTest?.isEnabled
                              ? "rgba(239,68,68,0.06)"
                              : "rgba(16,185,129,0.06)",
                            "&:hover": {
                              background: selectedTest?.isEnabled
                                ? "rgba(239,68,68,0.12)"
                                : "rgba(16,185,129,0.12)",
                              borderColor: selectedTest?.isEnabled
                                ? "rgba(239,68,68,0.5)"
                                : "rgba(16,185,129,0.5)",
                            },
                            "&:disabled": {
                              background: "#f1f5f9",
                              color: "#cbd5e1",
                              borderColor: "#e5e9ef",
                            },
                          }}
                        >
                          {disableLoading
                            ? selectedTest?.isEnabled
                              ? "Disabling…"
                              : "Enabling…"
                            : selectedTest?.isEnabled
                              ? "Disable Test"
                              : "Enable Test"}
                        </Button>
                      </>
                    )}

                    {/* Admin log links */}
                    {user?._doc?.role === "Admin" && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          flexWrap: "wrap",
                        }}
                      >
                        {[
                          { label: "Header logs", type: "header" },
                          {
                            label: "Investigation logs",
                            type: "pathologyInvestigation",
                          },
                        ].map((log) => (
                          <Box
                            key={log.type}
                            onClick={() =>
                              handleViewLog(selectedTest._id, log.type)
                            }
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 0.5,
                              cursor: "pointer",
                              background: "rgba(249,115,22,0.07)",
                              border: "1px solid rgba(249,115,22,0.2)",
                              borderRadius: "100px",
                              px: 1,
                              py: "3px",
                              "&:hover": {
                                background: "rgba(249,115,22,0.14)",
                                borderColor: "rgba(249,115,22,0.4)",
                              },
                              transition: "all 0.2s",
                            }}
                          >
                            <FormatAlignLeftIcon
                              sx={{ fontSize: "0.72rem", color: "#f97316" }}
                            />
                            <Typography
                              sx={{
                                fontSize: "0.68rem",
                                fontWeight: 600,
                                color: "#f97316",
                              }}
                            >
                              {log.label}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    )}

                    <Log
                      openLogDialog={openLogDialog}
                      handleCloseLog={handleCloseLog}
                      logs={headerLogs}
                    />
                  </Box>

                  {/* ── Right: status / edit toggle ── */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      flexShrink: 0,
                    }}
                  >
                    {noOfInvestigations === 0 && (
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 0.75,
                          background: "rgba(249,115,22,0.08)",
                          border: "1px solid rgba(249,115,22,0.25)",
                          borderRadius: "10px",
                          px: 1.5,
                          py: 0.75,
                        }}
                      >
                        <WarningAmberIcon
                          sx={{ fontSize: "0.9rem", color: "#f97316" }}
                        />
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color: "#f97316",
                          }}
                        >
                          No parameters saved
                        </Typography>
                      </Box>
                    )}

                    {noOfInvestigations > 0 &&
                      (user?._doc?.permissions?.investigationManagement
                        ?.edit ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            background: edit
                              ? "linear-gradient(135deg, rgba(16,185,129,0.12), rgba(16,185,129,0.06))"
                              : "#f8fafc",
                            border: "1.5px solid",
                            borderColor: edit
                              ? "rgba(16,185,129,0.4)"
                              : "#e5e9ef",
                            borderRadius: "10px",
                            px: 1.5,
                            py: 0.6,
                            transition: "all 0.25s ease",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "0.68rem",
                              fontWeight: 700,
                              color: edit ? "#059669" : "#94a3b8",
                              textTransform: "uppercase",
                              letterSpacing: ".4px",
                            }}
                          >
                            Edit Mode
                          </Typography>
                          <Switch
                            checked={edit}
                            onChange={handleToggleEdit}
                            size="small"
                            sx={{
                              "& .MuiSwitch-switchBase.Mui-checked": {
                                color: "#059669",
                              },
                              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                { background: "#10b981" },
                              "& .MuiSwitch-track": { background: "#cbd5e1" },
                            }}
                          />
                          {edit && (
                            <Box
                              sx={{
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                background: "#22c55e",
                                boxShadow: "0 0 0 2px rgba(34,197,94,0.25)",
                                flexShrink: 0,
                              }}
                            />
                          )}
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 0.75,
                            background: "rgba(239,68,68,0.07)",
                            border: "1px solid rgba(239,68,68,0.2)",
                            borderRadius: "10px",
                            px: 1.5,
                            py: 0.75,
                          }}
                        >
                          <LockIcon
                            sx={{ fontSize: "0.85rem", color: "#dc2626" }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 600,
                              color: "#dc2626",
                            }}
                          >
                            No edit permission
                          </Typography>
                        </Box>
                      ))}
                  </Box>
                </Box>

                {investigations &&
                  investigations.map((investigation, investigationIndex) => (
                    <Box
                      key={investigationIndex}
                      draggable={edit}
                      onDragStart={() => handleDragStart(investigationIndex)}
                      onDragOver={(e) => handleDragOver(e, investigationIndex)}
                      onDrop={handleDrop}
                      className={`draggable-item ${draggedIndex === investigationIndex ? "dragging" : ""} ${hoverIndex === investigationIndex && draggedIndex !== investigationIndex ? "hover" : ""}`}
                      sx={{
                        mb: 2,
                        p: 2,
                        pb: 1.5,
                        border: "1.5px solid",
                        borderColor: edit
                          ? "rgba(16,185,129,0.4)"
                          : "rgba(185,58,207,0.25)",
                        borderRadius: "14px",
                        background: edit
                          ? "linear-gradient(135deg, rgba(16,185,129,0.04), rgba(16,185,129,0.02))"
                          : "linear-gradient(135deg, rgba(42,84,166,0.03), rgba(185,58,207,0.02))",
                        position: "relative",
                        cursor: edit ? "grab" : "default",
                        boxShadow:
                          draggedIndex === investigationIndex
                            ? "0 8px 24px rgba(10,31,68,0.12)"
                            : "0 1px 6px rgba(10,31,68,0.05)",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          borderColor: edit
                            ? "rgba(16,185,129,0.6)"
                            : "rgba(185,58,207,0.4)",
                          boxShadow: "0 4px 16px rgba(10,31,68,0.08)",
                        },
                      }}
                    >
                      {/* ── Index badge ── */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: -10,
                          left: -10,
                          width: 26,
                          height: 26,
                          borderRadius: "50%",
                          background: edit
                            ? "linear-gradient(135deg, #0f6e56, #1d9e75)"
                            : "linear-gradient(135deg, #2a54a6, #b93acf)",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 800,
                          fontSize: "0.72rem",
                          boxShadow: edit
                            ? "0 3px 8px rgba(16,185,129,0.35)"
                            : "0 3px 8px rgba(185,58,207,0.35)",
                          zIndex: 999,
                        }}
                      >
                        {investigationIndex + 1}
                      </Box>

                      {/* Drag handle hint */}
                      {edit && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 10,
                            color: "rgba(16,185,129,0.4)",
                            display: "flex",
                            gap: "2px",
                          }}
                        >
                          {[0, 1].map((i) => (
                            <Box
                              key={i}
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "2px",
                              }}
                            >
                              {[0, 1, 2].map((j) => (
                                <Box
                                  key={j}
                                  sx={{
                                    width: 3,
                                    height: 3,
                                    borderRadius: "50%",
                                    background: "rgba(16,185,129,0.5)",
                                  }}
                                />
                              ))}
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* ── Main investigation row ── */}
                      <Grid container spacing={1.25} alignItems="center">
                        <Grid item xs={12} md={8}>
                          <TextField
                            fullWidth
                            label="Investigation Name"
                            variant="outlined"
                            size="small"
                            name="name"
                            value={investigation.name}
                            onChange={(e) =>
                              handleInvestigationChange(investigationIndex, e)
                            }
                            required
                            disabled={noOfInvestigations !== 0 && !edit}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                background: "#ffffff",
                                fontSize: "0.875rem",
                                fontWeight: 600,
                                "& fieldset": { borderColor: "#e5e9ef" },
                                "&:hover fieldset": {
                                  borderColor: edit ? "#10b981" : "#2a54a6",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: edit ? "#10b981" : "#b93acf",
                                  borderWidth: "1.5px",
                                },
                              },
                              "& .MuiInputLabel-root.Mui-focused": {
                                color: edit ? "#10b981" : "#b93acf",
                              },
                            }}
                          />
                        </Grid>

                        <Grid item xs={6} md={2}>
                          <Button
                            fullWidth
                            onClick={() => handleClickOpen(investigationIndex)}
                            disabled={
                              (noOfInvestigations !== 0 && !edit) ||
                              investigation.name?.length < 1
                            }
                            startIcon={
                              <ScienceIcon
                                sx={{ fontSize: "0.85rem !important" }}
                              />
                            }
                            sx={{
                              borderRadius: "10px",
                              textTransform: "none",
                              fontSize: "0.78rem",
                              fontWeight: 600,
                              py: 0.75,
                              background: "rgba(42,84,166,0.08)",
                              color: "#2a54a6",
                              border: "1.5px solid rgba(42,84,166,0.2)",
                              "&:hover": {
                                background: "rgba(42,84,166,0.14)",
                                borderColor: "#2a54a6",
                              },
                              "&:disabled": {
                                background: "#f1f5f9",
                                color: "#cbd5e1",
                                borderColor: "#e5e9ef",
                              },
                            }}
                          >
                            Methods
                          </Button>
                        </Grid>

                        <Grid item xs={6} md={2}>
                          <Button
                            fullWidth
                            onClick={() =>
                              handleClickOpenResult(investigationIndex)
                            }
                            disabled={
                              (noOfInvestigations !== 0 && !edit) ||
                              investigation.name?.length < 1
                            }
                            startIcon={
                              <AssignmentIcon
                                sx={{ fontSize: "0.85rem !important" }}
                              />
                            }
                            sx={{
                              borderRadius: "10px",
                              textTransform: "none",
                              fontSize: "0.78rem",
                              fontWeight: 600,
                              py: 0.75,
                              background: "rgba(185,58,207,0.08)",
                              color: "#b93acf",
                              border: "1.5px solid rgba(185,58,207,0.2)",
                              "&:hover": {
                                background: "rgba(185,58,207,0.14)",
                                borderColor: "#b93acf",
                              },
                              "&:disabled": {
                                background: "#f1f5f9",
                                color: "#cbd5e1",
                                borderColor: "#e5e9ef",
                              },
                            }}
                          >
                            Results
                          </Button>
                        </Grid>
                      </Grid>

                      {/* ── Sub-investigations ── */}
                      {investigation.subInvestigations.map(
                        (subInvestigation, subIndex) => (
                          <Box
                            key={subIndex}
                            sx={{
                              mt: 1.5,
                              p: 1.5,
                              border: "1.5px dashed",
                              borderColor: edit
                                ? "rgba(16,185,129,0.3)"
                                : "rgba(185,58,207,0.2)",
                              borderRadius: "10px",
                              background: edit
                                ? "rgba(16,185,129,0.03)"
                                : "rgba(185,58,207,0.03)",
                              position: "relative",
                            }}
                          >
                            {/* Sub-index indicator */}
                            <Box
                              sx={{
                                position: "absolute",
                                top: -8,
                                left: 10,
                                background: edit ? "#1d9e75" : "#b93acf",
                                color: "#fff",
                                fontSize: "0.55rem",
                                fontWeight: 700,
                                px: "6px",
                                py: "1px",
                                borderRadius: "100px",
                                letterSpacing: ".4px",
                                textTransform: "uppercase",
                              }}
                            >
                              sub {subIndex + 1}
                            </Box>

                            <Grid container spacing={1.25} alignItems="center">
                              <Grid item xs={12} md={8}>
                                <TextField
                                  fullWidth
                                  label="Sub-investigation Name"
                                  variant="outlined"
                                  size="small"
                                  name="subInvestigationName"
                                  value={subInvestigation.subInvestigationName}
                                  onChange={(e) =>
                                    handleSubInvestigationChange(
                                      investigationIndex,
                                      subIndex,
                                      e,
                                    )
                                  }
                                  required
                                  disabled={noOfInvestigations !== 0 && !edit}
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: "8px",
                                      background: "#ffffff",
                                      fontSize: "0.85rem",
                                      "& fieldset": { borderColor: "#e5e9ef" },
                                      "&:hover fieldset": {
                                        borderColor: edit
                                          ? "#10b981"
                                          : "#b93acf",
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: edit
                                          ? "#10b981"
                                          : "#b93acf",
                                        borderWidth: "1.5px",
                                      },
                                    },
                                  }}
                                />
                              </Grid>

                              <Grid item xs={6} md={2}>
                                <Button
                                  fullWidth
                                  onClick={() =>
                                    handleClickOpen(
                                      investigationIndex,
                                      subIndex,
                                      true,
                                    )
                                  }
                                  disabled={
                                    (noOfInvestigations !== 0 && !edit) ||
                                    subInvestigation.subInvestigationName
                                      ?.length < 1
                                  }
                                  startIcon={
                                    <ScienceIcon
                                      sx={{ fontSize: "0.8rem !important" }}
                                    />
                                  }
                                  sx={{
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    py: 0.65,
                                    background: "rgba(42,84,166,0.06)",
                                    color: "#2a54a6",
                                    border: "1px solid rgba(42,84,166,0.15)",
                                    "&:hover": {
                                      background: "rgba(42,84,166,0.12)",
                                    },
                                    "&:disabled": {
                                      background: "#f1f5f9",
                                      color: "#cbd5e1",
                                      borderColor: "#e5e9ef",
                                    },
                                  }}
                                >
                                  Methods
                                </Button>
                              </Grid>

                              <Grid item xs={6} md={2}>
                                <Button
                                  fullWidth
                                  onClick={() =>
                                    handleClickOpenResult(
                                      investigationIndex,
                                      subIndex,
                                      true,
                                    )
                                  }
                                  disabled={
                                    (noOfInvestigations !== 0 && !edit) ||
                                    subInvestigation.subInvestigationName
                                      ?.length < 1
                                  }
                                  startIcon={
                                    <AssignmentIcon
                                      sx={{ fontSize: "0.8rem !important" }}
                                    />
                                  }
                                  sx={{
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    py: 0.65,
                                    background: "rgba(185,58,207,0.06)",
                                    color: "#b93acf",
                                    border: "1px solid rgba(185,58,207,0.15)",
                                    "&:hover": {
                                      background: "rgba(185,58,207,0.12)",
                                    },
                                    "&:disabled": {
                                      background: "#f1f5f9",
                                      color: "#cbd5e1",
                                      borderColor: "#e5e9ef",
                                    },
                                  }}
                                >
                                  Results
                                </Button>
                              </Grid>
                            </Grid>

                            {/* Remove sub-investigation */}
                            {investigation.subInvestigations.length > 0 &&
                              !(noOfInvestigations !== 0 && !edit) && (
                                <Tooltip title="Remove sub-investigation" arrow>
                                  <IconButton
                                    onClick={() =>
                                      handleRemoveSubInvestigation(
                                        investigationIndex,
                                        subIndex,
                                      )
                                    }
                                    size="small"
                                    sx={{
                                      position: "absolute",
                                      top: -12,
                                      right: -12,
                                      width: 24,
                                      height: 24,
                                      borderRadius: "6px",
                                      background: "#ffffff",
                                      border:
                                        "1.5px solid rgba(239,68,68,0.25)",
                                      color: "#dc2626",
                                      zIndex: 999,
                                      "&:hover": {
                                        background: "rgba(239,68,68,0.1)",
                                        borderColor: "rgba(239,68,68,0.5)",
                                        "& .defaultIcon": { display: "none" },
                                        "& .hoverIcon": { display: "flex" },
                                      },
                                    }}
                                  >
                                    <DeleteIcon
                                      className="defaultIcon"
                                      sx={{ fontSize: "0.85rem" }}
                                    />
                                    <DeleteForeverIcon
                                      className="hoverIcon"
                                      sx={{
                                        fontSize: "0.85rem",
                                        display: "none",
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              )}
                          </Box>
                        ),
                      )}

                      {/* ── Add sub-investigation ── */}
                      {!(noOfInvestigations !== 0 && !edit) && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            mt: 1.5,
                          }}
                        >
                          <Button
                            onClick={() =>
                              handleAddSubInvestigation(investigationIndex)
                            }
                            startIcon={
                              <AddIcon
                                sx={{ fontSize: "0.85rem !important" }}
                              />
                            }
                            sx={{
                              borderRadius: "8px",
                              textTransform: "none",
                              fontSize: "0.72rem",
                              fontWeight: 600,
                              py: 0.5,
                              px: 1.5,
                              border: "1.5px dashed",
                              borderColor: edit
                                ? "rgba(16,185,129,0.4)"
                                : "rgba(185,58,207,0.3)",
                              color: edit ? "#059669" : "#b93acf",
                              background: "transparent",
                              "&:hover": {
                                background: edit
                                  ? "rgba(16,185,129,0.06)"
                                  : "rgba(185,58,207,0.06)",
                                borderColor: edit ? "#10b981" : "#b93acf",
                              },
                            }}
                          >
                            Add sub-investigation
                          </Button>
                        </Box>
                      )}

                      {/* ── Remove main investigation ── */}
                      {investigations.length > 1 &&
                        !(noOfInvestigations !== 0 && !edit) && (
                          <Tooltip title="Remove investigation" arrow>
                            <IconButton
                              onClick={() =>
                                handleRemoveInvestigation(investigationIndex)
                              }
                              size="small"
                              sx={{
                                position: "absolute",
                                bottom: -12,
                                right: -12,
                                width: 28,
                                height: 28,
                                borderRadius: "8px",
                                background: "#ffffff",
                                border: "1.5px solid rgba(239,68,68,0.25)",
                                color: "#dc2626",
                                zIndex: 999,
                                boxShadow: "0 2px 6px rgba(239,68,68,0.15)",
                                "&:hover": {
                                  background: "rgba(239,68,68,0.1)",
                                  borderColor: "rgba(239,68,68,0.5)",
                                  "& .defaultIcon": { display: "none" },
                                  "& .hoverIcon": { display: "flex" },
                                },
                              }}
                            >
                              <DeleteIcon
                                className="defaultIcon"
                                sx={{ fontSize: "1rem" }}
                              />
                              <DeleteForeverIcon
                                className="hoverIcon"
                                sx={{ fontSize: "1rem", display: "none" }}
                              />
                            </IconButton>
                          </Tooltip>
                        )}
                    </Box>
                  ))}

                {/* Add Investigation Button */}
                {investigations && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 2,
                      display:
                        noOfInvestigations !== 0 && !edit ? "none" : "flex",
                    }}
                  >
                    <Button
                      onClick={handleAddInvestigation}
                      startIcon={
                        <AddIcon sx={{ fontSize: "0.9rem !important" }} />
                      }
                      sx={{
                        textTransform: "none",
                        fontSize: "0.78rem",
                        fontWeight: 700,
                        borderRadius: "10px",
                        px: 2.5,
                        py: 0.75,
                        background: "linear-gradient(135deg, #0f6e56, #1d9e75)",
                        color: "#ffffff",
                        boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #064e3b, #0f6e56)",
                          boxShadow: "0 6px 18px rgba(16,185,129,0.4)",
                        },
                        transition: "all 0.25s ease",
                      }}
                    >
                      Add Investigation
                    </Button>
                  </Box>
                )}
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  {user?._doc?.permissions?.investigationManagement?.create && (
                    <Button
                      color="success"
                      aria-label="save"
                      variant="contained"
                      onClick={saveInvestigation}
                      sx={{ display: noOfInvestigations === 0 ? "" : "none" }}
                      disabled={loading}
                    >
                      <SaveIcon sx={{ fontSize: "20px" }} />
                      {!loading ? (
                        <Typography fontSize={15}>Save</Typography>
                      ) : (
                        <Typography fontSize={15}>Saving</Typography>
                      )}
                    </Button>
                  )}
                  <div style={{ display: edit ? "" : "none" }}></div>
                  {user?._doc?.permissions?.investigationManagement?.edit && (
                    <Button
                      color="warning"
                      aria-label="update"
                      variant="contained"
                      onClick={updateInvestigation}
                      sx={{ display: edit ? "" : "none" }}
                      disabled={loading}
                    >
                      <SaveIcon sx={{ fontSize: "20px" }} />
                      {!loading ? (
                        <Typography fontSize={15}>Update</Typography>
                      ) : (
                        <Typography fontSize={15}>Updating</Typography>
                      )}
                    </Button>
                  )}
                </Box>
              </Box>
            )}
          {selectedTest?.testCat === "radiology" && (
            <Box
              sx={{
                mt: 3,
                p: 3,
                border: "1px solid #ccc",
                borderRadius: "8px",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                backgroundColor: "#fff",
              }}
            >
              <Radiology
                test={selectedTest}
                investigation={selectedRadiologyInvestigation}
                setInvestigations={setInvestigations}
                setSelectedTest={setSelectedTest}
                setSelectedRadiologyInvestigation={
                  setSelectedRadiologyInvestigation
                }
                noOfInvestigations={noOfInvestigations}
                setOpenModal={setOpenModal}
              />
            </Box>
          )}
          {selectedTest?.testCat === "pathology" &&
            selectedTest?.reportType === "Widal" && (
              <Widal
                test={selectedTest}
                widalInvestigation={widalInvestigation}
                setOpenModal={setOpenModal}
                selectedTest={selectedTest}
                handleDisableTest={handleDisableTest}
                disableLoading={disableLoading}
              />
            )}
          {selectedTest?.testCat === "microbiology" && (
            <MicroBiology
              test={selectedTest}
              investigation={microBiologyInvestigation}
              setOpenModal={setOpenModal}
              selectedTest={selectedTest}
              handleDisableTest={handleDisableTest}
              disableLoading={disableLoading}
            />
          )}
        </Grid>

        {/* Test List Section */}
        {/* <Grid item xs={12} md={3}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "5px",
              border: "2px solid #ddd",
              borderRadius: "20px",
              backgroundColor: "#ffffff",
              marginBottom: 1,
            }}
          >
            <SearchIcon
              sx={{
                color: "#333",
                marginRight: "12px",
                fontSize: "24px",
                //
              }}
            />
            <InputBase
              placeholder="Search a test..."
              value={searchQuery}
              onChange={handleSearchChange}
              sx={{
                flex: 1,
                fontSize: "16px",
                color: "#555",
                border: "none",
                outline: "none",
                "&::placeholder": {
                  color: "#aaa",
                },
              }}
            />
          </Box>

          <Box
            sx={{
              border: "1px solid #e5e7eb", // Tailwind's gray-200
              borderRadius: "8px",
              backgroundColor: "#ffffff", // white background
              maxHeight: 600,
              overflowY: "auto",
              fontFamily: "Inter, sans-serif",
            }}
          >
            {filteredTests.length > 0 ? (
              <Box component="ul" sx={{ listStyle: "none", m: 0, p: 0 }}>
                {filteredTests.map((test) => (
                  <Box
                    key={test._id}
                    component="li"
                    sx={{
                      borderBottom: "1px solid #f1f5f9", // gray-100
                      px: 2,
                      py: 1.2,
                      fontSize: "0.85rem",
                      cursor: "pointer",
                      backgroundColor:
                        selectedTest?._id === test._id
                          ? "#f3f4f6"
                          : "transparent", // gray-100 on select
                      "&:hover": {
                        backgroundColor: "#f9fafb", // gray-50 hover
                      },
                    }}
                    onClick={() => handleTestSelection(test)}
                  >
                    <Typography sx={{ fontWeight: 500, color: "#111827" }}>
                      {test.testName}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: "#6b7280", display: "block", mt: 0.3 }}
                    >
                      Dept: {test.testDept} | Cat: {test.testCat} | ₹
                      {test.testPrice}
                    </Typography>
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography
                variant="body2"
                sx={{
                  textAlign: "center",
                  p: 2,
                  fontStyle: "italic",
                  color: "#6b7280",
                }}
              >
                No tests available.
              </Typography>
            )}
          </Box>
        </Grid> */}
        <Grid item xs={12} md={3}>
          <Box
            sx={{
              background: "#fff",
              borderRadius: "14px",
              border: "1px solid #e5e9ef",
              boxShadow: "0 2px 12px rgba(10,31,68,0.06)",
              overflow: "hidden",
            }}
          >
            {/* Search Header */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 1.5,
                py: 1.2,
                borderBottom: "1px solid #edf2f7",
                background: "#f8fafc",
              }}
            >
              <SearchIcon
                sx={{
                  color: "#10b981",
                  fontSize: 20,
                }}
              />

              <InputBase
                placeholder="Search test..."
                value={searchQuery}
                onChange={handleSearchChange}
                sx={{
                  flex: 1,
                  fontSize: ".84rem",

                  "& input::placeholder": {
                    color: "#94a3b8",
                    opacity: 1,
                  },
                }}
              />
            </Box>

            {/* List */}
            {testLoading ? (
              <Box
                sx={{
                  py: 8,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CircularProgress size={24} />
              </Box>
            ) : (
              <Box
                sx={{
                  maxHeight: 520,
                  overflowY: "auto",

                  "&::-webkit-scrollbar": {
                    width: 6,
                  },

                  "&::-webkit-scrollbar-thumb": {
                    background: "#d1d5db",
                    borderRadius: 10,
                  },

                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#9ca3af",
                  },
                }}
              >
                {filteredTests.length ? (
                  filteredTests.map((test) => {
                    const selected = selectedTest?._id === test._id;

                    return (
                      <Box
                        key={test._id}
                        sx={{
                          px: 1.5,
                          py: 1.2,
                          cursor: "pointer",

                          borderBottom: "1px solid #f1f5f9",

                          borderLeft: selected
                            ? "4px solid #10b981"
                            : "4px solid transparent",

                          background: selected ? "#ecfdf5" : "#fff",

                          transition: ".2s",

                          "&:hover": {
                            background: "#f8fafc",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            gap: 1,
                          }}
                        >
                          <Typography
                            onClick={() => handleTestSelection(test)}
                            sx={{
                              flex: 1,
                              fontSize: ".83rem",
                              fontWeight: 700,
                              color: "#0f172a",
                              lineHeight: 1.3,

                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",

                              "&:hover": {
                                color: "#10b981",
                              },
                            }}
                          >
                            {test.testName}
                          </Typography>

                          {user?._doc?.permissions?.testHeaderManagement
                            ?.delete && (
                            <Box
                              onClick={() => handleTestDelete(test)}
                              sx={{
                                width: 26,
                                height: 26,
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#ef4444",
                                cursor: "pointer",

                                "&:hover": {
                                  background: "#fef2f2",
                                },
                              }}
                            >
                              <DeleteIcon sx={{ fontSize: 16 }} />
                            </Box>
                          )}
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            gap: 0.6,
                            flexWrap: "wrap",
                            mt: 0.8,
                          }}
                        >
                          <Box
                            sx={{
                              px: 0.8,
                              py: 0.25,
                              borderRadius: "20px",
                              background: "#eef2ff",
                              color: "#4338ca",
                              fontSize: ".62rem",
                              fontWeight: 600,
                            }}
                          >
                            {test.testDept}
                          </Box>

                          <Box
                            sx={{
                              px: 0.8,
                              py: 0.25,
                              borderRadius: "20px",
                              background: "#f1f5f9",
                              color: "#475569",
                              fontSize: ".62rem",
                              fontWeight: 600,
                            }}
                          >
                            {test.testCat}
                          </Box>

                          <Box
                            sx={{
                              px: 0.8,
                              py: 0.25,
                              borderRadius: "20px",
                              background: "#ecfdf5",
                              color: "#047857",
                              fontSize: ".62rem",
                              fontWeight: 700,
                            }}
                          >
                            ₹ {test.testPrice}
                          </Box>
                        </Box>
                      </Box>
                    );
                  })
                ) : (
                  <Box
                    sx={{
                      py: 8,
                      textAlign: "center",
                    }}
                  >
                    <ScienceIcon
                      sx={{
                        fontSize: 40,
                        color: "#cbd5e1",
                        mb: 1,
                      }}
                    />

                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: "#475569",
                        fontSize: ".9rem",
                      }}
                    >
                      No Tests Found
                    </Typography>

                    <Typography
                      sx={{
                        color: "#94a3b8",
                        fontSize: ".75rem",
                        mt: 0.5,
                      }}
                    >
                      Try another search keyword
                    </Typography>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default TestHeaderForm;

const inputStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    background: "#ffffff",
    fontSize: "0.85rem",
    transition: "all 0.2s ease",

    "& fieldset": {
      borderColor: "#d1fae5",
    },

    "&:hover fieldset": {
      borderColor: "#16a34a",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#22c55e",
      boxShadow: "0 0 0 2px rgba(34,197,94,0.15)",
    },
  },
};

const labelStyle = {
  fontSize: "0.78rem",
  fontWeight: 600,
  color: "#475569",
  mb: 0.6,
};

const fieldStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    background: "#ffffff",

    "& fieldset": {
      borderColor: "#e5e9ef",
    },

    "&:hover fieldset": {
      borderColor: "#2a54a6",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#10b981",
      borderWidth: "1.5px",
    },
  },
};
